import withLoader from "../../../components/layouts/WithLoader";

import { useEffect, useState } from "react";
import SocieteService from "../../../services/Societe";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import CardSolde from "./CardSolde";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SocieteAndUserService from "../../../services/societeAndUser";

const ListFournisseurSolde = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [societes, setSocietes] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [idSociete, setIdSociete] = useState(null);
  const [btnSoldeClicked, setBtnSoldeClicked] = useState(false);
  const [soldeInfo, setSoldeInfo] = useState(null);

  const animatedComponents = makeAnimated();

  useEffect(() => {
    setOptions([]);
    startLoading();
       SocieteAndUserService.getAllPartenaires( "FOURNISSEUR",0)
        .then((response) => {
          if (Object.keys(response.data)[0] === "ListSociete") {
            setSocietes(response.data.ListSociete);
          setAlertMessage("success");

          localStorage.setItem("TypeTiersAccount", "F");

          const newOptions = response.data["ListSociete"].map((typeBill) => ({
            value: typeBill.id,
            label: typeBill.title,
          }));
          console.log("newOptions", newOptions);
          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
           
          }
        })
        .catch((e) => {
                  setAlertMessage("error " + e);

        }).finally(() => {
        stopLoading();
      });
    
  }, []);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setIdSociete(selectedOption.value);
  };

  const saveIdSociete = (e) => {
    //call ws
    startLoading();
    TierAccountService.getSoldeByIdFournisseur(getCurrentUserId(), idSociete)
      .then((response) => {
        setSoldeInfo(response.data.success);
        setBtnSoldeClicked(true);
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const resultSolde = () => {
    if (btnSoldeClicked) {
      if (soldeInfo !== null && soldeInfo !== undefined) {
        return (
          <CardSolde
            idSociete={idSociete}
            idAccount={soldeInfo?.id}
            title={soldeInfo?.title}
            typeSociete="du tier"
            solde={soldeInfo?.solde}
            lastUpdateDate={soldeInfo?.lastUpdate}
          />
        );
      }
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">Les Soldes des fournisseurs</h3>
              </div>
              <form
                className="form-horizontal"
                // onSubmit={saveIdSociete}
              ></form>
              {/* /.card-header */}
              <div className="card-body">
                <div class="row">
                  <div class="form-group col-4 col-sm-4">
                    <div>
                      <label>Choisir les fournisseurs</label>
                      <Select
                        value={selectedOption}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={options}
                        onChange={handleChange}
                        // defaultValue={selectedOption}
                        placeholder={"Tous"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button
                  type="submit"
                  onClick={saveIdSociete}
                  className="btn btn-dark float-right "
                >
                  Valider
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <div class="row">
          <div class="col-md-12">{resultSolde()}</div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(ListFournisseurSolde);
